import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';
import { KeycloakInitService } from './shared/auth-services/keycloak-init.service';
import { KeycloakService } from 'keycloak-angular';
import { authHeadersInterceptor } from './interceptors/auth-headers.interceptor';
import { PlatformService } from '@shared-lib/shared-services/platform.service.service';
import { ENVIRONMENT_CONFIG } from '@shared-lib/shared-services/environment-config.token';
import { environment } from '../environments/environment';

// Custom override: ChartRendererService uses custom bar-chart (pink) and pie-chart (70% radius)
import {
  ChartRendererService,
  CustomGlobalFilterService,
  CustomChartFilterHandlerService,
  CustomConfigService,
} from '@custom';
import { ChartRendererService as SharedChartRendererService } from '@shared-lib/shared-services/chart-renderer.service';
import { GlobalFilterService as SharedGlobalFilterService } from '@shared-lib/shared-services/global-filter-service';
import { ChartFilterHandlerService as SharedChartFilterHandlerService } from '@shared-lib/shared-services/chart-filter-handler.service';
import { ConfigService as SharedConfigService } from '@shared-lib/shared-services/config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    ),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authHeadersInterceptor])),

    // Keycloak initializer
    {
      provide: APP_INITIALIZER,
      useFactory: (KeycloakInitService: KeycloakInitService) => () =>
        KeycloakInitService.initKeycloak(),
      multi: true,
      deps: [KeycloakInitService],
    },

    // Platform API initializer
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (platformService: PlatformService) => () => platformService.getDashboardConfigFromApi('oh', 'customer-overview').toPromise(),
    //   multi: true,
    //   deps: [PlatformService],
    // },

    KeycloakService,
    // PlatformService,

    // Custom ChartRendererService override (uses pink bar-chart, 70% radius pie-chart)
    { provide: SharedChartRendererService, useClass: ChartRendererService },
    { provide: SharedGlobalFilterService, useClass: CustomGlobalFilterService },
    {
      provide: SharedChartFilterHandlerService,
      useClass: CustomChartFilterHandlerService,
    },
    { provide: SharedConfigService, useClass: CustomConfigService },

    // Environment config for shared library components
    {
      provide: ENVIRONMENT_CONFIG,
      useValue: {
        COMPANY_LOGO_SRC: environment.COMPANY_LOGO_SRC,
        COMPANY_LOGO_TEXT: environment.COMPANY_LOGO_TEXT,
        HELP_URL: environment.HELP_URL,
        FEEDBACK_URL: environment.FEEDBACK_URL,
      },
    },
  ],
};
